var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuditLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.8125C6.25 1.94917 6.95 1.25 7.8125 1.25H8.125C8.9538 1.25 9.74866 1.57924 10.3347 2.16529C10.9208 2.75134 11.25 3.5462 11.25 4.375V5.9375C11.25 6.80083 11.95 7.5 12.8125 7.5H14.375C15.2038 7.5 15.9987 7.82924 16.5847 8.41529C17.1708 9.00134 17.5 9.7962 17.5 10.625V13.4375C17.5 14.3 16.8 15 15.9375 15H7.8125C7.3981 15 7.00067 14.8354 6.70765 14.5424C6.41462 14.2493 6.25 13.8519 6.25 13.4375V2.8125Z",
    fill: "#8FA1A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.37534C12.5015 3.32413 12.1229 2.30781 11.4342 1.51367C12.8286 1.88031 14.1006 2.61073 15.1201 3.63024C16.1396 4.64975 16.87 5.92176 17.2367 7.31617C16.4425 6.62741 15.4262 6.24888 14.375 6.25034H12.8125C12.7296 6.25034 12.6501 6.21741 12.5915 6.15881C12.5329 6.1002 12.5 6.02072 12.5 5.93784V4.37534ZM4.0625 5.00034H5V13.4378C5 14.1838 5.29632 14.8991 5.82376 15.4266C6.35121 15.954 7.06658 16.2503 7.8125 16.2503H13.75V17.1878C13.75 18.0503 13.05 18.7503 12.1875 18.7503H4.0625C3.6481 18.7503 3.25067 18.5857 2.95765 18.2927C2.66462 17.9997 2.5 17.6022 2.5 17.1878V6.56284C2.5 5.69951 3.2 5.00034 4.0625 5.00034Z",
    fill: "#8FA1A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLog);
export default __webpack_public_path__ + "static/media/Audit Log.d1b43f95bd0d198cc5b80d28458ee08c.svg";
export { ForwardRef as ReactComponent };